import { AxiosRequestHeaders } from 'axios';
import { IncomingHttpHeaders } from 'http';

/* pass some frontend headers to backend */
export const proxyHeaders = (
    headers: IncomingHttpHeaders,
    headersToSet = [
        'cache-control',
        'cookie',
        'connection',
        'pragma',
        'user-agent',
        'origin',
        'referer',
    ],
): AxiosRequestHeaders => {
    const newHeaders: AxiosRequestHeaders = {};
    headersToSet.forEach((header) => {
        if (header in headers) {
            // FIXME: Cast here is better than just `any`, but it is still bad,
            // as it casts `string | string[] | undefined` to just `string`.
            newHeaders[header] = (headers as AxiosRequestHeaders)[header];
        }
    });

    return newHeaders;
};
